export enum VestingStatus {
  NOT_TOKENS_CLAIM = 'NOT_TOKENS_CLAIM',
  HAS_TOKENS_CLAIM = 'HAS_TOKENS_CLAIM',
  ENDED = 'ENDED',
}
